import { render, staticRenderFns } from "./ActivityV4.vue?vue&type=template&id=679f7956&scoped=true"
import script from "./ActivityV4.vue?vue&type=script&lang=js"
export * from "./ActivityV4.vue?vue&type=script&lang=js"
import style0 from "./ActivityV4.vue?vue&type=style&index=0&id=679f7956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679f7956",
  null
  
)

export default component.exports